export function MakeAsync(item, action) {
  if (!item?.async) {
    console.log("async data not found");
    return item;
  }

  const { status, reason } = item.async;

  // 🟢 حالة new + f
  if (status === "f" && reason === "new") {
    if (action === "delete") {
      return null; // delete directly
    }

    if (action === "update") {
      return item; // update without changing async
    }
  }

  // 🟢 حالة new + t
  if (status === "t" && reason === "new") {
    if (action === "update") {
      item.async = { status: "f", reason: "update" };
      return item;
    }

    if (action === "delete") {
      item.async = { status: "f", reason: "delete" };
      return item;
    }
  }

  if (status === "f" && reason === "update") {
    if (action === "delete") {
      item.async.reason = "delete";
      return item;
    }

    return item;
  }
  
  if (status === "t" && reason === "update") {
    if (action === "update") {
      item.async.status = "f";
      return item;
    }
  }

  if (reason === "delete") {
    return item;
  }

  return item;
}
